export function getGatewayColor(type) {
  if (type === 'basalam') return 'orange';
  if (type === 'digikala') return 'red';
  return 'purple';
}

export function resolveLogicalVariantKey(lv, index) {
  if (lv?._id) return String(lv._id);
  return `new-${index}`;
}

export function resolveLogicalVariantId(value) {
  if (!value) return null;
  if (typeof value === 'object' && value._id) return String(value._id);
  return String(value);
}

export function getGatewayMeta(gatewayRef, gateways) {
  if (!gatewayRef) {
    return {
      id: null,
      data: null,
      name: 'درگاه انتخاب نشده',
      type: 'custom',
      color: getGatewayColor('custom'),
    };
  }
  const gatewayId = gatewayRef.gateway?._id || gatewayRef.gateway;
  const gatewayList = gateways || [];
  const gatewayData = gatewayList.find((g) => g._id === gatewayId);
  return {
    id: gatewayId,
    data: gatewayData,
    name: gatewayData?.name || 'درگاه انتخاب نشده',
    type: gatewayData?.type || 'custom',
    color: getGatewayColor(gatewayData?.type),
  };
}

export function getVariantsInCell(variants, logicalKey, isUnmappedRow) {
  const list = variants || [];
  if (isUnmappedRow) {
    return list.filter((v) => !v.logicalVariantId);
  }
  return list.filter((v) => String(v.logicalVariantId) === String(logicalKey));
}

export function countMappedVariants(logicalVariants, gatewayRefs) {
  const keys = new Set(logicalVariants.map((lv, i) => resolveLogicalVariantKey(lv, i)));
  let mapped = 0;
  let unmapped = 0;
  (gatewayRefs || []).forEach((gatewayRef) => {
    if (!gatewayRef) return;
    (gatewayRef.variants || []).forEach((v) => {
      const id = v.logicalVariantId ? String(v.logicalVariantId) : null;
      if (id && keys.has(id)) mapped += 1;
      else if (!id) unmapped += 1;
      else unmapped += 1;
    });
  });
  return { mapped, unmapped };
}
